import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";

import { EditIcon } from "../../../../../resource/icons";
import { controlModal } from "../../../store/actions/voting.actions";
import useAllowChanges from "../../../hooks/useAllowChanges";
import Tree from "./tree";

import "./selected-addresses.scss";

const SelectedAddresses = memo(({ selectedAddresses, setFieldsValue }) => {
	const addresses = useSelector(
		(store) => store.votingStore.addresses.addresses
	);
	const changeable = useAllowChanges();

	const dispatch = useDispatch();
	return (
		<div className="selected-addresses">
			<div className="header">
				{changeable && (
					<>
						<span className="label">Адреса</span>
						<Button
							type="link"
							className="button"
							onClick={() => dispatch(controlModal(true, "root", addresses))}
						>
							<span>Изменить адреса</span>
							<EditIcon />
						</Button>
					</>
				)}
			</div>
			<Tree addresses={selectedAddresses} setFieldsValue={setFieldsValue} />
		</div>
	);
});
export default SelectedAddresses;
